import { Icon, Button } from "@sellar-io/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "usehooks-ts";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import { DISCOVER } from "../../constants/routes";
import {
  CollabageddonProductCard,
  CollabageddonProduct,
} from "./CollabageddonProductCard";
import { useCollabageddonStore } from "./CollabageddonStore";
import { BasketDrawer } from "./BasketDrawer";
import { zLayer } from "@sellar-io/components";

// Hardcoded page data
const collabageddonPageData = {
  title: "Collabageddon",
  description:
    "Celebrate Collabageddon 2025 with 12 one-off brews from 12 brilliant breweries. Order the full set in one click and join venues nationwide in pouring this year’s biggest craft beer collaboration.",
  logoUrl:
    "https://sellar.imgix.net/sellar-image-assets/collabageddon/collabageddon-logo.png",
  bannerSmallUrl:
    "https://sellar.imgix.net/sellar-image-assets/collabageddon/collabageddon-banner.png",
  bannerMediumUrl:
    "https://sellar.imgix.net/sellar-image-assets/collabageddon/collabageddon-banner.png",
  bannerLargeUrl:
    "https://sellar.imgix.net/sellar-image-assets/collabageddon/collabageddon-banner.png",
};

// Hardcoded product data
const collabageddonProducts: CollabageddonProduct[] = [
  {
    id: 103082,
    price: 8200,
    AvailabilityTierId: 778,
    PriceTierId: 722,
    SupplierId: 164,
    collab: "Collaboration with Origins (Fyne)",
  },
  {
    id: 102960,
    price: 9400,
    AvailabilityTierId: 3058,
    PriceTierId: 3073,
    SupplierId: 525,
    collab: "Collaboration with Campervan Brewery",
  },
  {
    id: 103363,
    price: 12500,
    AvailabilityTierId: 2524,
    PriceTierId: 2488,
    SupplierId: 133,
    collab: "Collaboration with Hand Brew Co",
  },
  {
    id: 103115,
    price: 12000,
    AvailabilityTierId: 2043,
    PriceTierId: 2080,
    SupplierId: 398,
    collab: "Collaboration with Thornbridge Brewery",
  },
  {
    id: 103173,
    price: 15000,
    AvailabilityTierId: 2347,
    PriceTierId: 2420,
    SupplierId: 452,
    collab: "Collaboration with Bullhouse Brew Co",
  },
  {
    id: 103032,
    price: 16000,
    AvailabilityTierId: 1198,
    PriceTierId: 1158,
    SupplierId: 233,
    collab: "Collaboration with Wild Horse Brewing Co",
  },
  {
    id: 102914,
    price: 7800,
    AvailabilityTierId: 605,
    PriceTierId: 1466,
    SupplierId: 7,
    collab: "Collaboration with Duration Brewing",
  },
  {
    id: 103109,
    price: 10200,
    AvailabilityTierId: 2043,
    PriceTierId: 2080,
    SupplierId: 398,
    collab: "Collaboration with Brolly Brewing",
  },
  {
    id: 102987,
    price: 11993,
    AvailabilityTierId: 1994,
    PriceTierId: 2063,
    SupplierId: 217,
    collab: "Collaboration with Fierce Beer",
  },
  {
    id: 102895,
    price: 8570,
    AvailabilityTierId: 1049,
    PriceTierId: 895,
    SupplierId: 193,
    collab: "Collaboration with Castle Rock Brewery",
  },
  {
    id: 103112,
    price: 11200,
    AvailabilityTierId: 2043,
    PriceTierId: 2080,
    SupplierId: 398,
    collab: "Collaboration with Castle Rock Brewery",
  },
  {
    id: 102398,
    price: 12600,
    AvailabilityTierId: 319,
    PriceTierId: 310,
    SupplierId: 78,
    collab: "Collaboration with Tap Social Movement",
  },
];

// Banner component for Choose My 6 functionality
const CollabageddonSelectionBanner = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isLargeScreen = useMediaQuery("(min-width: 1900px)");
  const {
    mode,
    selectedProducts,
    maxSelections,
    allProductsAdded,
    setMode,
    clearSelection,
    isSelectionComplete,
    addAllProducts,
  } = useCollabageddonStore();

  const handleAddAllToBasket = () => {
    addAllProducts(collabageddonProducts);
  };

  const handleConfirmSelection = () => {
    setMode(null);
  };

  const handleCancel = () => {
    setMode(null);
    clearSelection();
  };

  const handleRemoveAll = () => {
    setMode(null);
    clearSelection();
  };

  return (
    <div
      className={twMerge(
        `sticky top-[var(--nav-height)] ${zLayer.pinned} flex w-full flex-col justify-center bg-zinc-100 px-4 py-2`,
        isDesktop && "my-3 bg-zinc-100",
        !isDesktop && "overflow-hidden",
        isLargeScreen && "m-auto",
      )}
    >
      <div
        className={twMerge(
          "@container flex flex-col gap-2 border-b border-zinc-300 bg-zinc-50 p-4",
          isDesktop && "rounded-lg border border-zinc-300",
        )}
      >
        <div
          className={twMerge(
            "flex items-center justify-between gap-2 @2xl:flex-row",
            !isDesktop && "flex-col",
          )}
        >
          <div
            className={twMerge(
              "flex flex-wrap items-center gap-2",
              !isDesktop && "w-full flex-col",
            )}
          >
            {!mode && (
              <>
                <Button
                  className={twMerge(!isDesktop && "w-full")}
                  onClick={handleAddAllToBasket}
                >
                  ADD 12 BEERS TO BASKET
                </Button>
                {/*leaving in for now incase we want to re-add*/}
                {/*<Button*/}
                {/*  className={twMerge(!isDesktop && "w-full")}*/}
                {/*  onClick={handleChooseMySix}*/}
                {/*  color="secondary"*/}
                {/*>*/}
                {/*  <Icon icon={"PENCIL"} /> CHOOSE MY 6*/}
                {/*</Button>*/}
              </>
            )}

            {mode === "six" && (
              <>
                <Button
                  className={twMerge(!isDesktop && "w-full")}
                  onClick={handleConfirmSelection}
                  disabled={!isSelectionComplete()}
                >
                  CONFIRM MY SELECTION
                </Button>
                <Button
                  onClick={handleCancel}
                  color="tertiary"
                  className={twMerge("text-red-500", !isDesktop && "w-full")}
                >
                  CANCEL
                </Button>
              </>
            )}

            {mode === "all" && allProductsAdded && (
              <>
                <Button
                  disabled={true}
                  className={twMerge(!isDesktop && "w-full")}
                >
                  <span className="flex items-center gap-1">
                    <Icon icon={"CHECK"} />
                    ADDED 12 BEERS TO BASKET
                  </span>
                </Button>
                <Button
                  onClick={handleRemoveAll}
                  color="tertiary"
                  className={twMerge("text-red-500", !isDesktop && "w-full")}
                >
                  REMOVE ALL
                </Button>
              </>
            )}
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {mode === "six" && (
              <div className="text-sm text-zinc-600">
                {selectedProducts.length}/{maxSelections} beers selected
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const Collabageddon = () => {
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState<
    CollabageddonProduct | undefined
  >();
  const isLargeScreen = useMediaQuery("(min-width: 1900px)");
  const [basketDrawerActive, setBasketDrawerActive] = useState(false);

  const {
    mode,
    addProduct,
    removeProduct,
    isProductSelected,
    canAddMore,
    selectedProducts,
    clearSelection,
    setMode,
  } = useCollabageddonStore();

  const showBanner =
    !!collabageddonPageData.bannerLargeUrl &&
    !!collabageddonPageData.bannerMediumUrl &&
    !!collabageddonPageData.bannerSmallUrl;

  const showHeader =
    collabageddonPageData.description && collabageddonPageData.logoUrl;

  const onProductClicked = (product: CollabageddonProduct) => {
    console.log(selectedProduct);
    setSelectedProduct(product);
  };

  const onAddToBasket = (product: CollabageddonProduct) => {
    if (mode === "six") {
      if (isProductSelected(product.id)) {
        removeProduct(product.id);
      } else if (canAddMore()) {
        addProduct(product);
      }
    }
  };

  return (
    <>
      <div className="@container">
        <NavigationBar
          leftIcon={"CHEVRON_LEFT"}
          onClickLeftIcon={() => {
            navigate(DISCOVER);
          }}
          title={collabageddonPageData.title}
        />

        {showHeader && (
          <div className="w-full border-b border-zinc-300 bg-white p-4 py-6">
            <div className="m-auto flex w-full flex-col-reverse items-center gap-4 @4xl:flex-row">
              <div className="flex w-full flex-col gap-2 @4xl:w-1/2">
                {!!collabageddonPageData.logoUrl && (
                  <img
                    src={collabageddonPageData.logoUrl}
                    alt={collabageddonPageData.title}
                    className="hidden w-60 flex-none @3xl:ml-0 @4xl:block"
                  />
                )}
                {!!collabageddonPageData.description && (
                  <p>{collabageddonPageData.description}</p>
                )}
              </div>
              {showBanner && (
                <picture className="@4xl:h-[275px] @4xl:w-1/2">
                  <source
                    srcSet={collabageddonPageData.bannerLargeUrl}
                    media="(min-width: 1400px)"
                  />
                  <source
                    srcSet={collabageddonPageData.bannerMediumUrl}
                    media="(min-width: 968px)"
                  />
                  <img
                    src={collabageddonPageData.bannerSmallUrl}
                    alt={collabageddonPageData.title}
                    className="h-full w-full self-center rounded-lg object-cover"
                  />
                </picture>
              )}
            </div>
          </div>
        )}

        {/* Selection Banner */}
        <CollabageddonSelectionBanner />

        <div className="w-full">
          <div
            className={twMerge(
              "grid w-full flex-col gap-4 px-4",
              isLargeScreen && "m-auto",
            )}
          >
            {/* Product List - styled like SpotlightProductList but without queries/filters */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
              {collabageddonProducts.map((collabageddonProduct) => (
                <CollabageddonProductCard
                  key={collabageddonProduct.id}
                  collabageddonProduct={collabageddonProduct}
                  onClick={() => onProductClicked(collabageddonProduct)}
                  onAddToBasket={() => onAddToBasket(collabageddonProduct)}
                  isSelected={isProductSelected(collabageddonProduct.id)}
                  mode={mode}
                  canAddMore={canAddMore()}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Floating Button */}
        {(mode === "all" ||
          (mode === "six" && selectedProducts.length === 6)) && (
          <div className={`fixed right-6 bottom-6 ${zLayer.pinned}`}>
            <Button onClick={() => setBasketDrawerActive(true)}>
              <Icon icon="CART" />
              Basket: {selectedProducts.length} items
            </Button>
          </div>
        )}

        {/* Basket Drawer */}
        <BasketDrawer
          active={basketDrawerActive}
          setActive={setBasketDrawerActive}
          selectedProducts={selectedProducts}
          onRemoveAll={() => {
            clearSelection();
            setMode(null);
          }}
        />
      </div>
    </>
  );
};
